import {__isEmpty} from "../../_helpers/commons/utility.helper";
import TranscriptRefiner from "./transcriptRefiner";
import TranscriptHitBuilder from "./transcriptHitBuilder";

/**
 * Return search results by searching for query hits in data
 *
 * @param index the data index
 * @param data the actual data
 * @param query the query term to find
 * @returns {{hits: [], query: *}} result with query term and hits with context details
 */
function searchTranscript(index, data, query) {
    if (__isEmpty(index)) {         // if index is not present, build one on-the-go from the data
        index = prepareIndex(data)
    }
    const hitGroups = findHitGroups(index, query, data);
    const hits = [];
    hitGroups.map((hitGroup) => {
        const hitBuilder = new TranscriptHitBuilder(data, hitGroup);
        const hitData = hitBuilder.prepareHitData();
        hits.push(hitData)
    });
    return {
        "query": query,
        "hits" : hits,
    }
}

/**
 * Returns hit-groups (combined-hit-indexes) of the search hit
 *
 * @param index the data index
 * @param query the query term to find
 * @param data the search data
 * @returns {*} hit groups
 */
function findHitGroups(index, query, data) {
    // get search terms
    const queryTerms = TranscriptRefiner.splitQuery(query);

    // perform search on query terms
    let queryIndexes = {};
    queryTerms.forEach((q) => queryIndexes[q] = index.search(q))

    // refine query results
    const refiner = new TranscriptRefiner(queryIndexes, query, data);
    return refiner.performRefinement();
}

/**
 * Accepts data and indexes data for searching
 *
 * @param data the data to be searched
 */
function prepareIndex(data) {
    const FlexSearch = require("flexsearch");
    let index = FlexSearch.create();
    data.map((inst, arrIndex) => index.add(arrIndex, inst.w));
    return index;
}

export { searchTranscript, prepareIndex }
